/**
 * Safe error category mapping for Dealer Directory analytics (M12).
 */

import { DEALER_DIRECTORY_ERROR_CATEGORIES } from "../../constants/dealerDirectoryAnalyticsConstants";

export function mapDealerDirectoryErrorCategory(errorOrSource) {
  if (!errorOrSource) return DEALER_DIRECTORY_ERROR_CATEGORIES.UNKNOWN;

  const value = String(
    errorOrSource?.code ||
      errorOrSource?.category ||
      errorOrSource?.source ||
      errorOrSource?.message ||
      errorOrSource
  ).toLowerCase();

  if (value.includes("network") || value.includes("fetch") || value.includes("timeout")) {
    return DEALER_DIRECTORY_ERROR_CATEGORIES.NETWORK_ERROR;
  }
  if (value.includes("unavailable") || value.includes("503") || value === "error") {
    return DEALER_DIRECTORY_ERROR_CATEGORIES.SERVICE_UNAVAILABLE;
  }
  if (value.includes("parse") || value.includes("malformed") || value.includes("json")) {
    return DEALER_DIRECTORY_ERROR_CATEGORIES.PARSE_ERROR;
  }

  return DEALER_DIRECTORY_ERROR_CATEGORIES.UNKNOWN;
}
